module.exports = __webpack_public_path__ + "img/Flag_of_Australia.47d6befa.svg";